<template>
  <Button @click="$emit('onClick')" unstyled class="sidebar__btn">
    <div class="sidebar__btn-icon">
      <i class="pi pi-angle-left sidebar__btn-arrow" />
    </div>
  </Button>
</template>
